// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"199deb79","703":"4b596d95"}[chunkId] + ".chunk.js";
};